import { createReducer } from "../../../utils/redux/create-reducer";
import Types from "./types";

export const INITIAL_STATE = {
    details: {},
    stateList: [],
    faqList: [],
    isSSR: false,
    stateName: "",
    trafficFines: [],
    cmsContent: null,
    isInvalidState: false,
    testimonials: [],
    settledChallanCount: "",
    factsData: [],
    regNumberList: [],
    recentTransaction: null,
    isError: false,
    pageType: "",
    cityList: [],
    isInvalidCity: false
};

export const setSSRStatus = (state = INITIAL_STATE, {isSSR}) => {
    return { ...state, isSSR};
};

export const setDetails = (state = INITIAL_STATE, {data}) => {
    return {...state, ...data};
};

export const setRegNumberList = (state = INITIAL_STATE, { regNumberList }) => {
    return {...state, regNumberList };
};

export const setRecentTransaction = (state = INITIAL_STATE, { recentTransaction }) => {
    return {...state, recentTransaction };
};

export const HANDLERS = {
    [Types.SET_SSR_STATUS]: setSSRStatus,
    [Types.SET_DETAILS]: setDetails,
    [Types.SET_REG_NUMBER_LIST]: setRegNumberList,
    [Types.SET_RECENT_TRANSACTION]: setRecentTransaction
};

export default createReducer(INITIAL_STATE, HANDLERS);
